module.exports = __webpack_public_path__ + "img/yijia3.5b8c4f76.jpg";